import React from "react";
import CategoryCard from "components/Cards/CategoryCard/CategoryCard";
import ResultCard from "components/Cards/ResultCard/ResultCard";
import SearchBar from "../../components/SearchBar/SearchBar";
import axios from "axios";
import "./home.scss";

const Home = () => {
  const [products, setProducts] = React.useState(null);
  const [categories, setCategories] = React.useState([]);

  //API PRODUCTOS
  React.useEffect(() => {
    const fetchProduct = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/products/random/6`
        );
        setProducts(resultado.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchProduct();
  }, []);
  //API CATEGORIAS
  React.useEffect(() => {
    const fetchCategory = async () => {
      try {
        const resultado2 = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/categories`
        );
        setCategories(resultado2.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchCategory();
  }, []);

  return (
    <div className="homePage">
      <SearchBar />
      <section className="category_cards">
        <h2>Buscar por tipos de vehículos</h2>
        <div className="category_cards_container">
          {categories.map((category) => (
            <CategoryCard data={category} key={category.title} />
          ))}
        </div>
      </section>

      <section className="product_cards">
        <h2>Recomendados</h2>
        {products ? (
          <div className="product_cards_container">
            {products.map((product, i) => (
              <ResultCard data={product} key={product.title} />
            ))}
          </div>
        ) : (
          <h2 className="product__loading">Loading data...</h2>
        )}
      </section>
    </div>
  );
};
export default Home;
